import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../store/reducers';
import { SiteLinks } from 'src/app/models/config';
import { ConfigService } from 'src/app/services/config.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-visited-before',
    templateUrl: './visited-before.component.html',
    styleUrls: ['./visited-before.component.scss', '../../pages/welcome/welcome.component.scss'],
    standalone: false
})
export class VisitedBeforeComponent implements OnInit {

    public loggedIn: boolean
      public siteConfig: SiteLinks;

    constructor(private router: Router,
        private config: ConfigService,
        private store: Store<fromRoot.State>) {
        this.store.select(fromRoot.isPatientLoggedIn).subscribe((loggedIn: boolean) => {
            if (loggedIn) router.navigate(['rebook'])
        });

        this.config.getSiteConfig().pipe(takeUntilDestroyed()).subscribe(res=>{
              this.siteConfig = res;
        })
    }

    ngOnInit(): void {
    }

    redirect(url: string[]) {
        this.router.navigate(url)
    }
}
